// import { BrowserRouter, Routes, Route } from "react-router-dom";

// // Landing page components
// import HeroSection from "./components/heroSection";
// import Footer from "./components/footer";
// import OurWork from "./components/ourWork";
// import BrainStrome from "./components/brainstrome";
// import OurImpact from "./components/ourImpact";
// import Portfolio from "./components/portfolio";

// // Auth + Admin pages
// import Login from "./pages/customers/Login";
// import ForgotPassword from "./pages/customers/ForgotPassword";
// import CustomersPage from "./pages/customers/CustomersPage";
// import PrivateRoute from "./privateRoute";

// import "./App.css";

// // Landing page as a separate component
// const LandingPage = () => (
//   <>
//     <HeroSection />
//     <OurWork />
//     <BrainStrome />
//     <OurImpact />
//     <Portfolio />
//     <Footer />
//   </>
// );

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* 👇 Landing Page */}
//         <Route path="/" element={<LandingPage />} />

//         {/* 👇 Auth Pages */}
//         <Route path="/customers/login" element={<Login />} />
//         <Route path="/customers/forgot-password" element={<ForgotPassword />} />

//         {/* 👇 Protected Admin Page */}
//         <Route
//           path="/customers"
//           element={
//             <PrivateRoute>
//               <CustomersPage />
//             </PrivateRoute>
//           }
//         />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;

import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Navbar from "./components/navbar";
import HeroSection from "./components/heroSection";
// import PopUp from "./components/popUp"; // popUp component is called inside the navbar
import Footer from "./components/footer";
import OurWork from "./components/ourWork";
import BrainStrome from "./components/brainstrome";
// import AnimatedPath from "./components/animatedPath";
import OurImpact from "./components/ourImpact";
import Portfolio from "./components/portfolio";

// Auth + Admin pages
import Login from "./pages/customers/Login";
import ForgotPassword from "./pages/customers/ForgotPassword";
import CustomersPage from "./pages/customers/CustomersPage";
import PrivateRoute from "./privateRoute";

import "./App.css";

const LandingPage = () => (
  <div>
    {/* <Navbar /> */}
    <HeroSection />
    <OurWork />
    <BrainStrome />
    <OurImpact />
    {/* <AnimatedPath /> */}
    <Portfolio />
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />

        {/* Auth Pages */}
        <Route path="/customers/login" element={<Login />} />
        <Route path="/customers/forgot-password" element={<ForgotPassword />} />

        {/* Protected Admin Page - all Firestore enquiries */}
        <Route
          path="/customers"
          element={
            <PrivateRoute>
              <CustomersPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
